<template>
    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M8.33333 17.667C7.04467 17.667 6 18.7117 6 20.0003V33.3337C6 34.6223 7.04467 35.667 8.33333 35.667H31.6667C32.9553 35.667 34 34.6223 34 33.3337V20.0003C34 
                18.7117 32.9553 17.667 31.6667 17.667H8.33333ZM4 20.0003C4 17.6071 5.9401 15.667 8.33333 15.667H31.6667C34.0599 15.667 36 17.6071 36 20.0003V33.3337C36 35.7269 
                34.0599 37.667 31.6667 37.667H8.33333C5.9401 37.667 4 35.7269 4 33.3337V20.0003Z"
            fill="white"
        />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M15 6C13.9391 6 12.9217 6.42143 12.1716 7.17157C11.4214 7.92172 11 8.93913 11 10V15.6667H29V10C29 8.93913 28.5786 7.92172 27.8284 7.17157C27.0783 6.42143 
                26.0609 6 25 6H15ZM10.7574 5.75736C11.8826 4.63214 13.4087 4 15 4H25C26.5913 4 28.1174 4.63214 29.2426 5.75736C30.3679 6.88258 31 8.4087 31 10V16.6667C31 
                17.219 30.5523 17.6667 30 17.6667H10C9.44772 17.6667 9 17.219 9 16.6667V10C9 8.4087 9.63214 6.88258 10.7574 5.75736Z"
            fill="white"
        />
    </svg>
</template>
